export const languages = [
  { label: "ab", name: "Abkhaz", nativeName: "аҧсуа" },
  { label: "aa", name: "Afar", nativeName: "Afaraf" },
  { label: "af", name: "Afrikaans", nativeName: "Afrikaans" },
  { label: "ak", name: "Akan", nativeName: "Akan" },
  { label: "sq", name: "Albanian", nativeName: "Shqip" },
  { label: "am", name: "Amharic", nativeName: "አማርኛ" },
  { label: "ar", name: "Arabic", nativeName: "العربية" },
  { label: "an", name: "Aragonese", nativeName: "Aragonés" },
  { label: "hy", name: "Armenian", nativeName: "Հայերեն" },
  { label: "as", name: "Assamese", nativeName: "অসমীয়া" },
  { label: "av", name: "Avaric", nativeName: "авар мацӀ, магӀарул мацӀ" },
  { label: "ae", name: "Avestan", nativeName: "avesta" },
  { label: "ay", name: "Aymara", nativeName: "aymar aru" },
  { label: "az", name: "Azerbaijani", nativeName: "azərbaycan dili" },
  { label: "bm", name: "Bambara", nativeName: "bamanankan" },
  { label: "ba", name: "Bashkir", nativeName: "башҡорт теле" },
  { label: "eu", name: "Basque", nativeName: "euskara, euskera" },
  { label: "be", name: "Belarusian", nativeName: "Беларуская" },
  { label: "bn", name: "Bengali", nativeName: "বাংলা" },
  { label: "bh", name: "Bihari", nativeName: "भोजपुरी" },
  { label: "bi", name: "Bislama", nativeName: "Bislama" },
  { label: "bs", name: "Bosnian", nativeName: "bosanski jezik" },
  { label: "br", name: "Breton", nativeName: "brezhoneg" },
  { label: "bg", name: "Bulgarian", nativeName: "български език" },
  { label: "my", name: "Burmese", nativeName: "ဗမာစာ" },
  { label: "ca", name: "Catalan; Valencian", nativeName: "Català" },
  { label: "ch", name: "Chamorro", nativeName: "Chamoru" },
  { label: "ce", name: "Chechen", nativeName: "нохчийн мотт" },
  {
    label: "ny",
    name: "Chichewa; Chewa; Nyanja",
    nativeName: "chiCheŵa, chinyanja"
  },
  { label: "zh", name: "Chinese", nativeName: "中文 (Zhōngwén), 汉语, 漢語" },
  { label: "cv", name: "Chuvash", nativeName: "чӑваш чӗлхи" },
  { label: "kw", name: "Cornish", nativeName: "Kernewek" },
  { label: "co", name: "Corsican", nativeName: "corsu, lingua corsa" },
  { label: "cr", name: "Cree", nativeName: "ᓀᐦᐃᔭᐍᐏᐣ" },
  { label: "hr", name: "Croatian", nativeName: "hrvatski" },
  { label: "cs", name: "Czech", nativeName: "česky, čeština" },
  { label: "da", name: "Danish", nativeName: "dansk" },
  { label: "dv", name: "Divehi; Dhivehi; Maldivian;", nativeName: "ދިވެހި" },
  { label: "nl", name: "Dutch", nativeName: "Nederlands, Vlaams" },
  { label: "en", name: "English", nativeName: "English" },
  { label: "eo", name: "Esperanto", nativeName: "Esperanto" },
  { label: "et", name: "Estonian", nativeName: "eesti, eesti keel" },
  { label: "ee", name: "Ewe", nativeName: "Eʋegbe" },
  { label: "fo", name: "Faroese", nativeName: "føroyskt" },
  { label: "fj", name: "Fijian", nativeName: "vosa Vakaviti" },
  { label: "fi", name: "Finnish", nativeName: "suomi, suomen kieli" },
  { label: "fr", name: "French", nativeName: "français, langue française" },
  {
    label: "ff",
    name: "Fula; Fulah; Pulaar; Pular",
    nativeName: "Fulfulde, Pulaar, Pular"
  },
  { label: "gl", name: "Galician", nativeName: "Galego" },
  { label: "ka", name: "Georgian", nativeName: "ქართული" },
  { label: "de", name: "German", nativeName: "Deutsch" },
  { label: "el", name: "Greek, Modern", nativeName: "Ελληνικά" },
  { label: "gn", name: "Guaraní", nativeName: "Avañeẽ" },
  { label: "gu", name: "Gujarati", nativeName: "ગુજરાતી" },
  {
    label: "ht",
    name: "Haitian; Haitian Creole",
    nativeName: "Kreyòl ayisyen"
  },
  { label: "ha", name: "Hausa", nativeName: "Hausa, هَوُسَ" },
  { label: "he", name: "Hebrew (modern)", nativeName: "עברית" },
  { label: "hz", name: "Herero", nativeName: "Otjiherero" },
  { label: "hi", name: "Hindi", nativeName: "हिन्दी, हिंदी" },
  { label: "ho", name: "Hiri Motu", nativeName: "Hiri Motu" },
  { label: "hu", name: "Hungarian", nativeName: "Magyar" },
  { label: "ia", name: "Interlingua", nativeName: "Interlingua" },
  { label: "id", name: "Indonesian", nativeName: "Bahasa Indonesia" },
  {
    label: "ie",
    name: "Interlingue",
    nativeName: "Originally called Occidental; then Interlingue after WWII"
  },
  { label: "ga", name: "Irish", nativeName: "Gaeilge" },
  { label: "ig", name: "Igbo", nativeName: "Asụsụ Igbo" },
  { label: "ik", name: "Inupiaq", nativeName: "Iñupiaq, Iñupiatun" },
  { label: "io", name: "Ido", nativeName: "Ido" },
  { label: "is", name: "Icelandic", nativeName: "Íslenska" },
  { label: "it", name: "Italian", nativeName: "Italiano" },
  { label: "iu", name: "Inuktitut", nativeName: "ᐃᓄᒃᑎᑐᑦ" },
  {
    label: "ja",
    name: "Japanese",
    nativeName: "日本語 (にほんご／にっぽんご)"
  },
  { label: "jv", name: "Javanese", nativeName: "basa Jawa" },
  {
    label: "kl",
    name: "Kalaallisut, Greenlandic",
    nativeName: "kalaallisut, kalaallit oqaasii"
  },
  { label: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ" },
  { label: "kr", name: "Kanuri", nativeName: "Kanuri" },
  { label: "ks", name: "Kashmiri", nativeName: "कश्मीरी, كشميري‎" },
  { label: "kk", name: "Kazakh", nativeName: "Қазақ тілі" },
  { label: "km", name: "Khmer", nativeName: "ភាសាខ្មែរ" },
  { label: "ki", name: "Kikuyu, Gikuyu", nativeName: "Gĩkũyũ" },
  { label: "rw", name: "Kinyarwanda", nativeName: "Ikinyarwanda" },
  { label: "ky", name: "Kirghiz, Kyrgyz", nativeName: "кыргыз тили" },
  { label: "kv", name: "Komi", nativeName: "коми кыв" },
  { label: "kg", name: "Kongo", nativeName: "KiKongo" },
  {
    label: "ko",
    name: "Korean",
    nativeName: "한국어 (韓國語), 조선말 (朝鮮語)"
  },
  { label: "ku", name: "Kurdish", nativeName: "Kurdî, كوردی‎" },
  { label: "kj", name: "Kwanyama, Kuanyama", nativeName: "Kuanyama" },
  { label: "la", name: "Latin", nativeName: "latine, lingua latina" },
  {
    label: "lb",
    name: "Luxembourgish, Letzeburgesch",
    nativeName: "Lëtzebuergesch"
  },
  { label: "lg", name: "Luganda", nativeName: "Luganda" },
  {
    label: "li",
    name: "Limburgish, Limburgan, Limburger",
    nativeName: "Limburgs"
  },
  { label: "ln", name: "Lingala", nativeName: "Lingála" },
  { label: "lo", name: "Lao", nativeName: "ພາສາລາວ" },
  { label: "lt", name: "Lithuanian", nativeName: "lietuvių kalba" },
  { label: "lu", name: "Luba-Katanga", nativeName: "" },
  { label: "lv", name: "Latvian", nativeName: "latviešu valoda" },
  { label: "gv", name: "Manx", nativeName: "Gaelg, Gailck" },
  { label: "mk", name: "Macedonian", nativeName: "македонски јазик" },
  { label: "mg", name: "Malagasy", nativeName: "Malagasy fiteny" },
  { label: "ms", name: "Malay", nativeName: "bahasa Melayu, بهاس ملايو‎" },
  { label: "ml", name: "Malayalam", nativeName: "മലയാളം" },
  { label: "mt", name: "Maltese", nativeName: "Malti" },
  { label: "mi", name: "Māori", nativeName: "te reo Māori" },
  { label: "mr", name: "Marathi (Marāṭhī)", nativeName: "मराठी" },
  { label: "mh", name: "Marshallese", nativeName: "Kajin M̧ajeļ" },
  { label: "mn", name: "Mongolian", nativeName: "монгол" },
  { label: "na", name: "Nauru", nativeName: "Ekakairũ Naoero" },
  {
    label: "nv",
    name: "Navajo, Navaho",
    nativeName: "Diné bizaad, Dinékʼehǰí"
  },
  { label: "nb", name: "Norwegian Bokmål", nativeName: "Norsk bokmål" },
  { label: "nd", name: "North Ndebele", nativeName: "isiNdebele" },
  { label: "ne", name: "Nepali", nativeName: "नेपाली" },
  { label: "ng", name: "Ndonga", nativeName: "Owambo" },
  { label: "nn", name: "Norwegian Nynorsk", nativeName: "Norsk nynorsk" },
  { label: "no", name: "Norwegian", nativeName: "Norsk" },
  { label: "ii", name: "Nuosu", nativeName: "ꆈꌠ꒿ Nuosuhxop" },
  { label: "nr", name: "South Ndebele", nativeName: "isiNdebele" },
  { label: "oc", name: "Occitan", nativeName: "Occitan" },
  { label: "oj", name: "Ojibwe, Ojibwa", nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ" },
  {
    label: "cu",
    name: "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
    nativeName: "ѩзыкъ словѣньскъ"
  },
  { label: "om", name: "Oromo", nativeName: "Afaan Oromoo" },
  { label: "or", name: "Oriya", nativeName: "ଓଡ଼ିଆ" },
  { label: "os", name: "Ossetian, Ossetic", nativeName: "ирон æвзаг" },
  { label: "pa", name: "Panjabi, Punjabi", nativeName: "ਪੰਜਾਬੀ, پنجابی‎" },
  { label: "pi", name: "Pāli", nativeName: "पाऴि" },
  { label: "fa", name: "Persian", nativeName: "فارسی" },
  { label: "pl", name: "Polish", nativeName: "polski" },
  { label: "ps", name: "Pashto, Pushto", nativeName: "پښتو" },
  { label: "pt", name: "Portuguese", nativeName: "Português" },
  { label: "qu", name: "Quechua", nativeName: "Runa Simi, Kichwa" },
  { label: "rm", name: "Romansh", nativeName: "rumantsch grischun" },
  { label: "rn", name: "Kirundi", nativeName: "kiRundi" },
  { label: "ro", name: "Romanian, Moldavian, Moldovan", nativeName: "română" },
  { label: "ru", name: "Russian", nativeName: "русский язык" },
  { label: "sa", name: "Sanskrit (Saṁskṛta)", nativeName: "संस्कृतम्" },
  { label: "sc", name: "Sardinian", nativeName: "sardu" },
  { label: "sd", name: "Sindhi", nativeName: "सिन्धी, سنڌي، سندھی‎" },
  { label: "se", name: "Northern Sami", nativeName: "Davvisámegiella" },
  { label: "sm", name: "Samoan", nativeName: "gagana faa Samoa" },
  { label: "sg", name: "Sango", nativeName: "yângâ tî sängö" },
  { label: "sr", name: "Serbian", nativeName: "српски језик" },
  { label: "gd", name: "Scottish Gaelic; Gaelic", nativeName: "Gàidhlig" },
  { label: "sn", name: "Shona", nativeName: "chiShona" },
  { label: "si", name: "Sinhala, Sinhalese", nativeName: "සිංහල" },
  { label: "sk", name: "Slovak", nativeName: "slovenčina" },
  { label: "sl", name: "Slovene", nativeName: "slovenščina" },
  { label: "so", name: "Somali", nativeName: "Soomaaliga, af Soomaali" },
  { label: "st", name: "Southern Sotho", nativeName: "Sesotho" },
  {
    label: "es",
    name: "Spanish; Castilian",
    nativeName: "español, castellano"
  },
  { label: "su", name: "Sundanese", nativeName: "Basa Sunda" },
  { label: "sw", name: "Swahili", nativeName: "Kiswahili" },
  { label: "ss", name: "Swati", nativeName: "SiSwati" },
  { label: "sv", name: "Swedish", nativeName: "svenska" },
  { label: "ta", name: "Tamil", nativeName: "தமிழ்" },
  { label: "te", name: "Telugu", nativeName: "తెలుగు" },
  { label: "tg", name: "Tajik", nativeName: "тоҷикӣ, toğikī, تاجیکی‎" },
  { label: "th", name: "Thai", nativeName: "ไทย" },
  { label: "ti", name: "Tigrinya", nativeName: "ትግርኛ" },
  {
    label: "bo",
    name: "Tibetan Standard, Tibetan, Central",
    nativeName: "བོད་ཡིག"
  },
  { label: "tk", name: "Turkmen", nativeName: "Türkmen, Түркмен" },
  { label: "tl", name: "Tagalog", nativeName: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔" },
  { label: "tn", name: "Tswana", nativeName: "Setswana" },
  { label: "to", name: "Tonga (Tonga Islands)", nativeName: "faka Tonga" },
  { label: "tr", name: "Turkish", nativeName: "Türkçe" },
  { label: "ts", name: "Tsonga", nativeName: "Xitsonga" },
  { label: "tt", name: "Tatar", nativeName: "татарча, tatarça, تاتارچا‎" },
  { label: "tw", name: "Twi", nativeName: "Twi" },
  { label: "ty", name: "Tahitian", nativeName: "Reo Tahiti" },
  { label: "ug", name: "Uighur, Uyghur", nativeName: "Uyƣurqə, ئۇيغۇرچە‎" },
  { label: "uk", name: "Ukrainian", nativeName: "українська" },
  { label: "ur", name: "Urdu", nativeName: "اردو" },
  { label: "uz", name: "Uzbek", nativeName: "zbek, Ўзбек, أۇزبېك‎" },
  { label: "ve", name: "Venda", nativeName: "Tshivenḓa" },
  { label: "vi", name: "Vietnamese", nativeName: "Tiếng Việt" },
  { label: "vo", name: "Volapük", nativeName: "Volapük" },
  { label: "wa", name: "Walloon", nativeName: "Walon" },
  { label: "cy", name: "Welsh", nativeName: "Cymraeg" },
  { label: "wo", name: "Wolof", nativeName: "Wollof" },
  { label: "fy", name: "Western Frisian", nativeName: "Frysk" },
  { label: "xh", name: "Xhosa", nativeName: "isiXhosa" },
  { label: "yi", name: "Yiddish", nativeName: "ייִדיש" },
  { label: "yo", name: "Yoruba", nativeName: "Yorùbá" },
  { label: "za", name: "Zhuang, Chuang", nativeName: "Saɯ cueŋƅ, Saw cuengh" }
];
